import { Fragment, useContext } from "react";
import { Outlet,Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { selectCurrentUser } from "../../store/user/user.selector";

import { ReactComponent as CrwnLogo } from "../../assets/crown.svg";
import {NavigationContainer, NavLink,NavLinks,LogoContainer} from './navigation-component-style.jsx'
// import { UserContext } from "../../contexts/user.context";
// import { CartContext} from "../../contexts/cart.context";
import { selectIsCartOpen } from "../../store/cart/cart.selector";
// import { signOutUser } from "../../utils/firebase/firebase.util";
import { signOutStart } from "../../store/user/user.action";

import CartIcon from '../../components/card-icon/card-icon.component';
import CartDropdown from "../../components/cart-dropdown/cart-dropdown.component";



const Navigation=()=>{
  
  const currentUser= useSelector(selectCurrentUser)

  
  // const {isCartOpen}=useContext(CartContext)

  const isCartOpen =useSelector(selectIsCartOpen)
  const dispatch=useDispatch()
  const signOutUser = ()=>dispatch(signOutStart())

  
 
  
    return(
      <Fragment>
        <NavigationContainer>
            <LogoContainer to='/'>
                <CrwnLogo className="logo"/>
            </LogoContainer>
            <NavLinks>
            <NavLink to='/shop'>Shop</NavLink>
              {
                currentUser ?(
                  <NavLink as='span' onClick={signOutUser}>SignOut</NavLink>)
                  : ( <NavLink to='/auth'>SignIn</NavLink>)
                
              }
              <CartIcon />
               
            </NavLinks>
           { isCartOpen && <CartDropdown />}
            
          
        </NavigationContainer>
      <Outlet />
      </Fragment>
    )
  }
  export default Navigation;